function orderBySomeField(array, field = 'sort_number') {
  if (!Array.isArray(array)) return array;
  return array.sort((prev, current) => (prev[field] > current[field] ? 1 : -1));
}

export default orderBySomeField;
